import ReactFullpage from '@fullpage/react-fullpage';
import { styled } from '@volkswagen-onehub/components-core';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import { TriggerProps } from 'src/feature-app';
import { VerticalLine } from 'src/components';
import { FirstSlide, FourthSlide, SecondSlide, ThirdSlide } from './NuevoTaigo';

const pluginWrapper = () => {
  require('./NuevoTaigo/fullpage.extensions.min'); // Optional. Required when using the "fadingEffect" extension.
  require('./NuevoTaigo/fullpage.scrollHorizontally.min'); // Optional. Required when using the "fadingEffect" extension.
};

const Wrapper = styled.div`
  position: relative;
`;
const VerticalWrapper = styled.div`
  position: absolute;
  top: calc(var(--100vh) - 100px);
  z-index: 100;
  left: 85%;

  @media all and (min-height: 500px) {
    left: 50%;
  }
`;

/**
 * Hay que precargar las imágenes del tercer slide para que cuando el usuario llegue ya estén cargandas y no se pierda la animación.
 * @param linkUrl
 */
const appendLinkToHead = (linkUrl: string) => {
  const link: HTMLLinkElement = document.createElement('link');
  link.href = linkUrl;
  link.rel = 'preload';
  link.as = 'image';
  document.getElementsByTagName('head')[0].append(link);
};

export function LanzamientoTaigoTrigger({ setSelectedJourney }: TriggerProps) {
  const fullpageApiRef = React.useRef(null);
  const [number, setNumber] = useState(1);
  const [loadAnimation, setLoadAnimation] = useState(true);
  const [showScrollLine, setShowScrollLine] = useState(true);

  useEffect(() => {
    appendLinkToHead('https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/vw-taigo-1.png');
    appendLinkToHead('https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/vw-taigo-2.png');
    appendLinkToHead('https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/vw-taigo-3.png');
    appendLinkToHead('https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/vw-taigo-1-mob.png');
    appendLinkToHead('https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/vw-taigo-2-mob.png');
    appendLinkToHead('https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/vw-taigo-3-mob.png');
  }, []);

  return (
    <Wrapper>
      {showScrollLine ? (
        <VerticalWrapper>
          <VerticalLine />
        </VerticalWrapper>
      ) : null}
      <ReactFullpage
        licenseKey={'95970DF9-34D2421B-A197BC6D-E0690DB7'}
        scrollHorizontallyKey={'dm9sa3N3YWdlbi5lc19BOXBjMk55YjJ4c1NHOXlhWHB2Ym5SaGJHeDVkTWQ='}
        scrollingSpeed={1000}
        pluginWrapper={pluginWrapper}
        scrollHorizontally
        fitToSection={false}
        controlArrows={false}
        normalScrollElements={'#normalScrollElements'}
        onLeave={(origin, destination, direction) => {
          // Control de la animación
          if (destination.index === 0) {
            setLoadAnimation(true);
          } else {
            setLoadAnimation(false);
          }

          // Control del la línea del scroll
          if (destination.isLast) {
            setShowScrollLine(false);
          } else {
            setShowScrollLine(true);
          }
        }}
        onSlideLeave={(section, origin, destination, direction) => {
          if (typeof destination.index === 'number') {
            setNumber(destination.index + 1);
          }
        }}
        afterLoad={(origin, destination, direction) => {
          if (destination.index + 1 === $('#fullpage .section').length) {
            fullpageApiRef.current.setAutoScrolling(false);
          }

          $(document).scroll(function () {
            var last_section = $('#fullpage').find('.section').last();
            var offset = last_section.offset();
            var w = $(window);

            if (offset.top - w.scrollTop() > 0) {
              fullpageApiRef.current.setAutoScrolling(true);
            }
          });
        }}
        render={({ state, fullpageApi }) => {
          if (!fullpageApiRef.current) {
            fullpageApiRef.current = fullpageApi;
          }
          return (
            <ReactFullpage.Wrapper>
              <div className="section">
                <FirstSlide loadAnimation={loadAnimation} />
              </div>
              <div className="section">
                <SecondSlide />
              </div>
              <div className="section">
                <ThirdSlide number={number} fullPageApi={fullpageApiRef.current} />
              </div>
              <div className="section">
                <FourthSlide setSelectedJourney={setSelectedJourney} />
              </div>
            </ReactFullpage.Wrapper>
          );
        }}
      />
    </Wrapper>
  );
}
